@if (operadora) {
  <ul class="p-0 m-0 list-none flex align-items-center">
    <li>
      <a
        pButton
        pRipple
        type="button"
        class="p-button-text"
      href="http://www.ans.gov.br/qualificacao_consumidor/informacoes_operadora.asp?co_operadora_param={{
        operadora.cd_registro_ans
      }}"
        target="_blank"
        rel="noopener"
        >
        Resultado IDSS na ANS
        <i class="pi pi-external-link text-xs ml-2"></i>
      </a>
    </li>
    <li>
      <a
        pButton
        pRipple
        type="button"
        class="p-button-text"
        href="https://penanoprod:PRDAUpent001@www.ans.gov.br/pentaho/api/repos/:public:Sala%20Externo:SalaPrincipal.wcdf/generatedContent?codOperadora={{operadora.cd_registro_ans}}"
        target="_blank"
        rel="noopener"
        >
        Sala de situação
        <i class="pi pi-external-link text-xs ml-2"></i>
      </a>
    </li>
    <li>
      <a
        pButton
        pRipple
        type="button"
        class="p-button-text"
        href="http://cnes.datasus.gov.br/pages/estabelecimentos/consulta.jsp?search={{ operadora.nr_cnpj_raiz }}"
        target="_blank"
        rel="noopener"
        >
        CNES de mesmo CNPJ
        <i class="pi pi-external-link text-xs ml-2"></i>
      </a>
    </li>
    <li>
      <a
        pButton
        pRipple
        type="button"
        class="p-button-text"
      href="http://www.ans.gov.br/ConsultaPlanosConsumidor/pages/ConsultaPlanos.xhtml?coOperadora={{
        operadora.cd_registro_ans
      }}"
        target="_blank"
        rel="noopener"
        >
        Consulta planos operadora
        <i class="pi pi-external-link text-xs ml-2"></i>
      </a>
    </li>
  </ul>
}
